module.exports = __webpack_public_path__ + "img/noshi.7ecd62ca.png";